/*tab js */
// let tabs = document.querySelectorAll(".tabs li");
// let tabsArray = Array.from(tabs);
// let divs = document.querySelectorAll(".contentext > div");
// let divsArray = Array.from(divs);

// tabsArray.forEach((ele) => {
//   ele.addEventListener("click", function (e) {
//     tabsArray.forEach((ele) => {
//       ele.classList.remove("active");
//     });
//     e.currentTarget.classList.add("active");
//     divsArray.forEach((div) => {
//       div.style.display = "none";
//     });
//     document.querySelector(e.currentTarget.dataset.cont).style.display = "block";
//   });
// });

/*shipping bar js */
function update_fsbContainer() {
    const custom_fsb_container = document.querySelector('.custom_fsb_container');
    const main_fsb_container = document.querySelector('#fsb_container');
    if (custom_fsb_container && main_fsb_container) {
      custom_fsb_container.innerHTML = '';
      custom_fsb_container.appendChild(main_fsb_container.cloneNode(true));
      const old_closeButton = custom_fsb_container.querySelector('#fsb_close');
      if(old_closeButton){
        const isCloseButton = old_closeButton.innerHTML;
        const newCloseBtn = document.createElement('span');
        newCloseBtn.classList.add('fsb_close_btn');
        if (isCloseButton) {
          newCloseBtn.innerHTML = isCloseButton;
          custom_fsb_container.appendChild(newCloseBtn);
          old_closeButton.hidden = true;
        }
      }
    }
  }
 document.addEventListener("click", (e) => {
    const isCloseButton = e.target.closest('.fsb_close_btn');
      if (isCloseButton) {
        document.querySelector('#fsb_close')?.click();
      }
  });
  function waitForElement(selector, callback) {
      const observer = new MutationObserver(() => {
        const element = document.querySelector(selector);
        if (element) {
          callback(element);
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  waitForElement('#fsb_container', (main_fsb_container) => {
      const observer = new MutationObserver(() => {
        update_fsbContainer();
      });
      observer.observe(main_fsb_container, {
        childList: true,
        subtree: true,
        attributes: true
      });
    });
/*collection page fiter open*/
$(document).ready(function(){

    $(".menu-bar").click(function () {
      $(".navigation").toggleClass("display");
      $("body").toggleClass("overflow");
      $(this).toggleClass("active");
      $("aside#main-collection-filters").toggleClass("active-filter");
    });
    $('#FacetsWrapperDesktop details').attr('open','');
    $('.submenu-toggle-click.has-submenu>h5').click(function (e) {
        $(this).parent().find('.sub-menu').slideToggle();
        $(this).parent().siblings().children().next().slideUp();
        return false;
      });
  })

/*cart icon*/
setInterval(function(){
    // remove visually hidden class form cart icon header
  $('#cart-icon-bubble').find('.svg-wrapper + span').removeClass('visually-hidden');
  }, 0);
/*add to cart */

var varVal;
var replaceId;
$('.input-price-row').find('input[type=radio]').on('change', function(){

    varVal = $(this).val();

   $(this).closest('form').find('.radio-container input[type=radio]').removeAttr('checked');
      $(this).attr('checked', 'checked');
    $(this).closest('form').find('.variants-list-items').each(function(){
        var masterVal = $(this).text();
        console.log(masterVal);
        if(masterVal.includes(varVal)){
            replaceId = $(this).data('variantid');
            $(this).closest('form').find('input[name=id]').val(replaceId);
        }
    })
});

// go through all product and check quantity if 0 then add out of stock
$('.input-price-row').each(function(){
  var masterValSold = $(this).find('.radio-container input[type=radio]').data('inventory');
  if(masterValSold == 0){
      var inputRow = $(this).closest('.input-price-row');
      inputRow.addClass('out-of-stock');
     inputRow.find('.fearured-price').html('<h6>Out of Stock</h6>');
  }
});


// quantity error on custom product cards
$('.card-submit').on('click',function(e){
    e.preventDefault();
    var formSub = $(this).closest('form');
    var inputQuant = parseInt($(this).siblings('#quantity').val());
    var checkedQuant = formSub.find('input:checked').data('inventory');

    if(inputQuant > checkedQuant){
        formSub.find('.quantity-error').text(`You can't add more than ${checkedQuant} items`);
    }else{
        formSub.submit();
    }
});

// quantity error on custom accessories product cards
$('.card-submit-access').on('click',function(e){
    e.preventDefault();
    var formSub = $(this).closest('form');
    var inputQuantAccess = parseInt($(this).siblings('#quantity').val());
    var checkedQuantAcess = formSub.find('input[name=id]').data('access-quantity');

    if(inputQuantAccess > checkedQuantAcess){
        formSub.find('.quantity-error').text(`You can't add more than ${checkedQuantAcess} items`);
    }else{
        formSub.submit();
    }
});

function initializeQuantityDropdown() {
    document.querySelectorAll('.quantity_box').forEach(function(element) {
        element.style.display = "none";
    });

    document.querySelectorAll('.quantity-dropdown').forEach(function(dropdown) {
        const optionTen = dropdown.querySelector('option[value="10"]');
        if (optionTen) {
            optionTen.textContent = "10+";
        }
        dropdown.addEventListener('change', function() {
            let selectval = this.value;
            const quantityInput = this.closest('.count-add-to-cart').querySelector('.quantity');
            quantityInput.value = selectval;
            if (selectval === "10+" || selectval === "10") {
                this.closest('.selecte_wrapper').style.display = "none";
                this.closest('.count-add-to-cart').querySelector('.quantity_box').style.display = "block";
            } else {
                this.closest('.count-add-to-cart').querySelector('.quantity_box').style.display = "none";
                this.closest('.selecte_wrapper').style.display = "block";
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', function() {
    initializeQuantityDropdown();
});


let radio_container = document.querySelectorAll(".radio-container input");
let discount_money = document.querySelector(".discount_price_itg .discount_money");
let discount_percentage = document.querySelector(".discount_percentage span")

radio_container.forEach((item)=>{
    item.addEventListener("change", function () {
    let parentDiv = this.closest('.input-price-row');
    let delPrice = parentDiv.querySelector('.del-price .money').innerText;
    let discountPrice = parentDiv.querySelector('.discount-price .money').innerText;
     let originalPrice = parseFloat(delPrice.replace(/[^0-9.-]+/g, '')); // Removes $ sign and converts to float
    let discountedPrice = parseFloat(discountPrice.replace(/[^0-9.-]+/g, ''));

    let discountCalMoney = parseFloat(originalPrice - discountedPrice).toFixed(2);
    let discountPercentage = discountCalMoney / originalPrice;
    let discountPercentageFinal = parseFloat(discountPercentage * 100).toFixed(2);
      discount_money.innerHTML = "$"+discountCalMoney;
      discount_percentage.innerHTML = discountPercentageFinal;
    })
})

function windowLoad() {
  const checkedinput = document.querySelector(".radio-container input:checked");

  if (!checkedinput) {
    console.log("No checked input found.");
    return;
  }

  const parentDiv = checkedinput.closest('.input-price-row');
  if (!parentDiv) {
    console.log("Parent .input-price-row not found.");
    return;
  }

  const delPriceElem = parentDiv.querySelector('.del-price .money');
  const discountPriceElem = parentDiv.querySelector('.discount-price .money');

  if (!delPriceElem || !discountPriceElem) {
    console.log("Price elements not found.");
    return;
  }

  const delPrice = delPriceElem.innerText;
  const discountPrice = discountPriceElem.innerText;

  const originalPrice = parseFloat(delPrice.replace(/[^0-9.-]+/g, ''));
  const discountedPrice = parseFloat(discountPrice.replace(/[^0-9.-]+/g, ''));

  const discountCalMoney = parseFloat(originalPrice - discountedPrice).toFixed(2);
  const discountPercentage = (originalPrice - discountedPrice) / originalPrice;
  const discountPercentageFinal = parseFloat(discountPercentage * 100).toFixed(2);

  const discount_money = document.getElementById("discount_money");
  const discount_percentage = document.getElementById("discount_percentage");

  if (discount_money) discount_money.innerHTML = "$" + discountCalMoney;
  if (discount_percentage) discount_percentage.innerHTML = discountPercentageFinal + "%";
}

windowLoad();


 /* view_scall_link grading-scale popup js moved into sections/view-grading-scale.liquid (self-contained, Monk-resilient) */


// load more add on collection page

function initializeSortAndPagination() {
    $(document).ready(function () {
        $(document).on("click", ".facet-filters__sort option", function (e) {
            var sortValue = $(this).data("sort-value");
            loadContent(sortValue);
        });

        $(document).on("click", ".load-more", function (e) {
            e.preventDefault();
            $("#loading").show();
            var nextUrl = $(this).attr("href");

            $.ajax({
                url: nextUrl,
                success: function (data) {
                    $(".sInfinity-Loop").append($(data).find(".sInfinity-Loop").html());
                    $("#sInfinity-Pagination").html(
                        $(data).find("#sInfinity-Pagination").html()
                    );
                },
                complete: function () {
                    $("#loading").hide();

                    document.querySelectorAll('.custom-site-btn').forEach(button => {
                        if (button.__boundAddToCart) return;
                        button.__boundAddToCart = true;
                        button.addEventListener('click', function (event) {
                            event.preventDefault();
                            if (button.dataset.adding === '1') return;
                            button.dataset.adding = '1';
                            setTimeout(function () { button.dataset.adding = ''; }, 1500);

                            const variantId = this.getAttribute('data-variant-id');
                            const quantity = this.closest('.count-add-to-cart').querySelector('.quantity').value || 1;
                            let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

                            if (variantId) {
                                addToCart(variantId, quantity, cart);
                            } else {
                                // console.error("Variant ID is missing.");
                            }
                        });
                    });

                    initializeQuantityDropdown();
                    gradingScale();
                }
            });
        });
    });
}

initializeSortAndPagination();

/*judge me name split */
$(document).ready(function() {
    $('.jdgm-carousel-item__reviewer-name').each(function() {
      var text = $(this).text().trim();
      var words = text.split(" ");
      if (words.length > 1) {
        var firstWord = words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase();
        var secondWordFirstChar = words[1].charAt(0).toUpperCase();
        var newText = firstWord + " " + secondWordFirstChar + ".";
        $(this).text(newText);
      }
    });
  });


/*top to buttom button */
const Srollbutton = document.querySelector('.social_widget');

const displayButton = () => {
  window.addEventListener('scroll', () => {
    if (window.scrollY > 200) {
      Srollbutton.style.display = "block";
    } else {
      Srollbutton.style.display = "none";
    }
  });
 };
displayButton();

/* variant change product price */
document.querySelectorAll('.variant-radio').forEach(function(radio) {
  var priceContainer = document.querySelector('.price__container');

  radio.addEventListener('change', function(event) {
    var variantId = event.target.getAttribute('data-variant'); 
    var form = document.querySelector('.product-form');
    var productIdInput = form.querySelector('input[name="id"]');

    if (productIdInput) {
      productIdInput.value = variantId;
    } else {
    }
  });
});

/*price change variant change product page */
document.querySelectorAll('.variant-radio').forEach(function(radio) {
  radio.addEventListener('change', function(event) {

          var comparePriceHtml = event.target.getAttribute('data-campare-price');
        var PriceHtml = event.target.getAttribute('data-price');
        var prices = document.querySelectorAll(".itg_price_wrappers .price-item--last .money")

          prices.forEach(function(priceElement){
            if(priceElement.textContent.trim() !== comparePriceHtml){
              priceElement.textContent = comparePriceHtml;
            }
          });

        var price = document.querySelectorAll(".itg_price_wrappers .price-item--regular .money")
          price.forEach(function(priceElementcustom){
            if(priceElementcustom.textContent.trim() !== PriceHtml){
              priceElementcustom.textContent = PriceHtml;
            }
          });
  });
});


  // Select all product containers
  const media = document.querySelector('.product media-gallery slider-component');
const title = document.querySelector('.product__info-wrapper .product__title h1');
if(media && title){
    media.addEventListener("mouseover" , function(){
      if (title) {
     title.classList.add("hovered-title") 
  }
    })
      media.addEventListener("mouseleave" , function(){
      if (title) {
    title.classList.remove("hovered-title")
  }
    })

}

/* Mobile-only: clicking anywhere on .input-price-row checks the radio inside.
   Desktop keeps native behavior (label/radio click). */
(function () {
  document.addEventListener('click', function (e) {
    if (window.innerWidth > 749) return;

    const row = e.target.closest('.input-price-row');
    if (!row) return;

    // If click was on a radio or label (native handling), bail
    if (e.target.closest('input[type="radio"], label')) return;

    const radio = row.querySelector('input[type="radio"]');
    if (!radio) return;
    if (radio.disabled || radio.classList.contains('disabled')) return;
    if (radio.checked) return;

    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    radio.dispatchEvent(new Event('input', { bubbles: true }));
  });
})();
